var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExploreNewReleases(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Explore",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "solid/stars",
    style: {
      mixBlendMode: "overlay"
    },
    fill: "#FCFCFC"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.536712,175.740091 L344.74334,131.410006 L389.073425,109.203378 L344.74334,86.9967507 L322.536712,42.6666661 L300.330085,86.9967507 L256,109.203378 L300.330085,131.410006 L322.536712,175.740091 Z M442.302794,202.354776 L428.995452,175.740091 L415.68811,202.354776 L389.073425,215.662118 L415.68811,228.969461 L428.995452,255.584146 L442.302794,228.969461 L468.917479,215.662118 L442.302794,202.354776 Z M346.074074,264.982456 L258.910981,252.25731 L219.903834,173.078622 C212.917479,158.939571 192.706952,158.773229 185.637427,173.078622 L146.630279,252.25731 L59.467186,264.982456 C43.8310586,267.22807 37.5100709,286.523717 48.9044829,297.585445 L112.031189,359.131904 L97.0604285,446.128655 C94.39896,461.847954 110.949967,473.65822 124.756335,466.256011 L202.77063,425.169591 L280.784925,466.256011 C294.674464,473.575049 311.1423,461.847954 308.480832,446.128655 L293.593242,359.131904 L356.719948,297.585445 C368.031189,286.523717 361.710202,267.22807 346.074074,264.982456 Z",
    id: "stars"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExploreNewReleases);
export default __webpack_public_path__ + "static/media/iconExploreNewReleases.48adf7fa.svg";
export { ForwardRef as ReactComponent };